import { c as _c } from "react/compiler-runtime";
import { DragDropContext, Droppable, type OnDragEndResponder } from "@hello-pangea/dnd";
import { Stack } from "@mui/material";
import React from "react";
type DraggableArgsListProps = {
  onDragEnd: OnDragEndResponder;
  children: React.ReactNode;
  renderAddButton?: () => React.ReactNode;
};
export const DraggableArgsList: React.FC<DraggableArgsListProps> = t0 => {
  const $ = _c(6);
  const {
    onDragEnd,
    children,
    renderAddButton
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== renderAddButton) {
    t1 = <Droppable droppableId="args-list">{provided => <Stack {...provided.droppableProps} ref={provided.innerRef} spacing={1} sx={{
        mt: 1
      }}>{children}{provided.placeholder}{renderAddButton?.()}</Stack>}</Droppable>;
    $[0] = children;
    $[1] = renderAddButton;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== onDragEnd || $[4] !== t1) {
    t2 = <DragDropContext onDragEnd={onDragEnd}>{t1}</DragDropContext>;
    $[3] = onDragEnd;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};